import { render, staticRenderFns } from "./amortization.vue?vue&type=template&id=7022bab6"
import script from "./amortization.vue?vue&type=script&lang=js"
export * from "./amortization.vue?vue&type=script&lang=js"
import style0 from "./amortization.vue?vue&type=style&index=0&id=7022bab6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports